const autoNgTemplateLoaderTemplate1 = require('./template.html');

import angular from 'angular';

import { RegistryRepositoryTagController } from './controller';

angular.module('portainer.registrymanagement').component('registryRepositoryTagView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: RegistryRepositoryTagController,
});
